import React from "react";
import "./style.scss";
import { useTranslation } from "react-i18next";

export default function SectionRecommendations() {
  const { t } = useTranslation();
  return (
    <section className="ads-section-recommendations">
      <div className="ads-section-recommendations__recommendation">
        <div className="ads-section-recommendations__recommendation__top-rec">
          <p>{t("ads_title")}</p>
          <br />
          <p>{t("ads_section_recommendations.recommendation_one")}</p>
          <br />
          <p>{t("ads_section_recommendations.recommendation_two")}</p>
          <br />
          <div className="ads-section-recommendations__recommendation__top-rec__steps"><p>{t("ads_section_recommendations.step_1")}</p>
            <p>{t("ads_section_recommendations.step_2")}</p>
            <p>{t("ads_section_recommendations.step_3")}</p></div>
        </div>
      </div>
    </section>
  );
}
